module.exports = __webpack_public_path__ + "img/o2o.387b4616.svg";